import $ from 'jquery'

export class MenuPrimary {

  constructor() {
    this.$container = $('header.header nav.header-primary')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'body': 'disable-overflow',
      'header': 'header.header',
      'hidden': 'header-hidden',
      'scroll': 'header-scroll',
      'submenu': 'has-submenu',
      'submenuItems': 'submenu',
      'itemSubmenu': 'item-submenu',
      'burgerButton': 'burger-button',
      'submenuProduct': 'submenu-product',
      'submenuContent': 'submenu-content',
      'dataSubmenuLink': 'data-submenu-link',
      'dataSubmenuContent': 'data-submenu-content',
      'hasSublinks': 'has-sublinks',
      'sublinksVisible': 'sublinks-visible',
      'iconClose': 'icon-close_1',
      'iconBurger': 'icon-burger',
      'itemTitle': 'item-title',
      'linkReturn': 'link-return',
      'overlay': 'header-overlay',
      'submenuProductAllLink': 'submenu-product-all-link',
      'active': 'active'
    }
    this.bpHeader = 768
    this.bpHeaderDesktop = 1279
    this.$window = $(window)
    this.$html = $('html')
    this.$body = $('body')
    this.$header = $('header.header')
    this.$submenu = this.$container.find(`.${this.classes.submenu} > .link`)
    this.$subItems = this.$container.find(`.${this.classes.submenuItems} > .container > ul > li > .link`)
    this.$itemTitle = this.$header.find(`.${this.classes.itemTitle} > .link`)
    this.$burgerButton = this.$header.find(`.${this.classes.burgerButton}`)
    this.$linkReturn = this.$header.find(`.${this.classes.linkReturn}`)
    this.$titleSublink = this.$header.find(`.${this.classes.hasSublinks} > .link`)
    this.previousScroll = 0

    this.$submenu.on('click', this.handlerClickSubmenu.bind(this))
    this.$subItems.on('click', this.handlerClickSubmenuItems.bind(this))
    this.$itemTitle.on('click', this.handlerClickItemTitle.bind(this))
    this.$burgerButton.on('click', this.handlerClickMenuBurger.bind(this))
    this.$linkReturn.on('click', this.handlerClickLinkReturn.bind(this))
    this.$titleSublink.on('click', this.handlerClickTitleSublink.bind(this))
    this.$window.on('resize', this.handleResize.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))

    $(document).on('click', this.handleClickDocument.bind(this))
  }

  handleScroll(e) {
    if (this.$window.scrollTop() > 0) {
      let currentScroll = this.$window.scrollTop();

      if (currentScroll > this.previousScroll && currentScroll > this.$header.height()) {
        this.$body.addClass(this.classes.hidden)
        this.$header.removeClass(this.classes.scroll)
      } else {
        this.$body.removeClass(this.classes.hidden)
        this.$header.addClass(this.classes.scroll)
      }

      this.previousScroll = currentScroll;

      return
    }

    // this.$body.removeClass(this.classes.body)
    this.$body.removeClass(this.classes.hidden)
    this.$header.removeClass(this.classes.scroll)
  }

  handlerClickSubmenu(e) {
    e.preventDefault()
    let $submenu = $(e.currentTarget).parent()

    if ($submenu.find(`.${this.classes.submenuProduct}`)) {
      if ($(window).width() < this.bpHeaderDesktop) {
        $submenu.find(`.${this.classes.active}`).removeClass(this.classes.active)
      } else if ($submenu.find(`.${this.classes.submenuContent}.${this.classes.active}`).length === 0) {
        $submenu.find('li').eq(0).addClass(this.classes.active)
        $submenu.find(`.${this.classes.submenuContent}`).eq(0).addClass(this.classes.active)
      }
    }

    if ($submenu.hasClass(this.classes.active)) {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      this.$header.removeClass(this.classes.active)
    } else {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      $submenu.addClass(this.classes.active)
      this.$header.addClass(this.classes.active)
    }
  }

  handlerClickTitleSublink(e) {
    $(e.currentTarget).parent().toggleClass(this.classes.sublinksVisible)
  }

  handlerClickSubmenuItems(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $itemParent = $item.parent()

    $itemParent.closest('ul').find(`.${this.classes.active}`).removeClass(this.classes.active)
    $itemParent.addClass(this.classes.active)

    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      let $submenu = $item.closest(`.${this.classes.submenuProduct}`)

      $submenu.find(`.${this.classes.active}[${this.classes.dataSubmenuContent}]`).removeClass(this.classes.active)
      $submenu.find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    }
  }

  handlerClickMenuBurger(e) {
    e.preventDefault()

    if (this.$header.hasClass(this.classes.active)) {
      this.$header.removeClass(this.classes.active)
      this.$body.removeClass(this.classes.body)
      this.$burgerButton.find('i').removeClass(this.classes.iconClose).addClass(this.classes.iconBurger)
    } else {
      this.$header.addClass(this.classes.active)
      this.$body.addClass(this.classes.body)
      this.$burgerButton.find('i').removeClass(this.classes.iconBurger).addClass(this.classes.iconClose)
    }
  }

  handlerClickLinkReturn(e) {
    e.preventDefault()
    let $linkReturn = $(e.currentTarget)
    $linkReturn.closest(`.${this.classes.active}`).removeClass(this.classes.active)
  }

  handlerClickItemTitle(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      $item.closest(`.${this.classes.submenuProduct}`).find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    } else {
      $item.parent().find(`.${this.classes.itemSubmenu}`).addClass(this.classes.active)
    }
  }

  handleResize() {
    this.$header.find(`.${this.classes.active}`).removeClass(this.classes.active)
    this.$header.removeClass(this.classes.active)
    this.$body.removeClass(this.classes.body)
    this.$burgerButton.find('i').removeClass(this.classes.iconClose).addClass(this.classes.iconBurger)
  }

  /**
   * Événement au clic sur le document
   *
   * @param e
   */
  handleClickDocument(e) {
    let $element = $(e.target)
    let $header = $element.closest(`${this.classes.header}`)

    if ($header.length === 0) {
      this.handleResize()
    }
  }
}
